module.exports = __webpack_public_path__ + "static/img/湖州银行@2x.7fedcc36.png";